import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import Popups from '../../components/Popup';
import { usePopupContext } from '../../contexts/PopupContext';

const ApiErrorPopupContainer = ({ error }) => {
  const { closePopup } = usePopupContext();

  return <Popups.ErrorPopup error={error} onClose={closePopup} />;
};

ApiErrorPopupContainer.propTypes = {
  error: PropTypes.node,
};

function mapStateToProps(state, props) {
  return {
    error: props.popup.getIn(['props', 'error']),
  };
}

export { ApiErrorPopupContainer };
export default connect(mapStateToProps, {}, mergeProps, connectOptions)(memo(ApiErrorPopupContainer));
